export default "__VITE_ASSET__CZa22FwD__"